import {useEffect, useState} from "react";
import ToastContainers from "./Utils/ToastContainer";
import PageNotFound404 from "./Errors/PageNotFound404";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Base from "./Pages/Base";
import Home from "./Pages/Home";
import Project from "./Pages/Project";
import Services from "./Pages/Services";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import ServiceDetails from "./Pages/ServiceDetails";
import AI_model from "./Pages/AI_model";
import TechArmorSecurity from "./Pages/TechPages/TechArmorSecurity";
import BlockChainForge from "./Pages/TechPages/BlockChainForge";
import DigitalIQConsulting from "./Pages/TechPages/DigitalIQConsulting";
import RapidAppInnovative from "./Pages/TechPages/RapidAppInovative";
import RoboLogicLabs from "./Pages/TechPages/RoboLogicLabs";
import ProjectDetail from "./Pages/ProjectDetail";
import AiModelList from "./Pages/AiModelList";
import "./App.css";


function App() {
    const [showFlagPopup, setShowFlagPopup] = useState(true);

    useEffect(() => {
        const timerId = setTimeout(() => setShowFlagPopup(false), 20000);
        return () => clearTimeout(timerId);
    }, []);

    return (
        <>
            <BrowserRouter>

                {/* ToastContainer */}
                <ToastContainers/>

                {showFlagPopup && (
                    <div className="palestine-popup" role="dialog" aria-live="polite">
                        <div className="palestine-popup__card">
                            <button
                                type="button"
                                className="palestine-popup__close"
                                aria-label="Close popup"
                                onClick={() => setShowFlagPopup(false)}
                            >
                                ×
                            </button>
                            <p className="palestine-popup__text">لَا تَحْزَنْ إِنَّ اللَّهَ مَعَنَا</p>
                            <div className="palestine-flag" role="img" aria-label="Palestinian flag">
                                <span className="flag-stripe flag-stripe--black"></span>
                                <span className="flag-stripe flag-stripe--white"></span>
                                <span className="flag-stripe flag-stripe--green"></span>
                                <span className="flag-triangle"></span>
                            </div>
                        </div>
                    </div>
                )}

                {/* Routes */}
                <Routes>

                    {/* Web Routes */}
                    <Route path='/' element={<Base><Home/></Base>}/>
                    <Route path='/projects' element={<Base><Project title="Project"/></Base>}/>
                    <Route path='/project-details'
                           element={<Base><ProjectDetail title="Project Details"/></Base>}/>
                    <Route path='/services' element={<Base><Services title="Services"/></Base>}/>
                    <Route path='/service-details' element={<Base><ServiceDetails title="Service Details"/></Base>}/>
                    <Route path='/ai-models-details' element={<Base><AI_model title="AI Models"/></Base>}/>
                    <Route path='/ai-models' element={<Base><AiModelList title="AI Models"/></Base>}/>
                    <Route path='/about-us' element={<Base><About title="About Us"/></Base>}/>
                    <Route path='/contact-us' element={<Base><Contact title="Contact Us"/></Base>}/>

                    {/* OTHER PAGES */}
                    <Route path='/tech-armor-security'
                           element={<Base><TechArmorSecurity title="Tech Armor Security"/></Base>}/>
                    <Route path='/block-chain-forge'
                           element={<Base><BlockChainForge title="Block Chain Forge"/></Base>}/>
                    <Route path='/digital-iq-consulting'
                           element={<Base><DigitalIQConsulting title="Digital IQ Consulting"/></Base>}/>
                    <Route path='/rapid-app-innovative'
                           element={<Base><RapidAppInnovative title="Rapid App Innovative"/></Base>}/>
                    <Route path='/robo-logic-labs' element={<Base><RoboLogicLabs title="Robo Logic Labs"/></Base>}/>


                    <Route path='*' element={<PageNotFound404/>}/>

                </Routes>

            </BrowserRouter>
        </>
    );
}

export default App;
